const width = (schema) =>{
   return schema && schema.width ? schema.width : '';
}

export default width;